<section
  class="section-container"
  cdkDropList
  [cdkDropListData]="tasks"
  cdkDropListOrientation="vertical"
  (cdkDropListDropped)="listDropped($event)"
>
  <article
    class="section-container__item"
    *ngFor="let task of tasks"
    cdkDrag
    cdkDragLockAxis="y"
    cdkDragBoundary=".section-container"
    [cdkDragDisabled]="isAggregatedTask"
    [class.pt-0]="isAggregatedTask"
    [class.m-0]="isAggregatedTask"
  >
    <div class="section-container__item__header" *ngIf="!isAggregatedTask">
      <div [class.section-container__item__header--unreached-stage]="stageNotReached(task)">
        <div class="section-container__item__header__screen-width">
          <div class="section-container__item__header__left-icons">
            <mat-icon cdkDragHandle svgIcon="drag_indicator" [matTooltip]="'Drag me'" class="hover-show"></mat-icon>
            <mat-icon
              [class.visibility-hidden]="!task.children?.length"
              [matTooltip]="task.expanded ? 'Collapse' : 'Expand'"
              [svgIcon]="task.expanded ? 'expand_more' : 'chevron_right'"
              (click)="sectionClick(task)"
            >
            </mat-icon>
          </div>
          <!-- Section title -->
          <p class="section-container__item__header__title" [routerLink]="[task.id]" [class.placeholder]="!task.title">
            {{ task.title || 'Section title' }}
          </p>
          <!-- Task dependencies -->
          <ng-container *ngIf="task.task_type === 'task' && task.predecessor_tasks_count > 0">
            <div class="mr-5">
              <mat-icon [svgIcon]="'merge_type'" [matTooltip]="'Has ' + task.predecessor_tasks_count + ' Predecessors'">
              </mat-icon>
            </div>
          </ng-container>
          <!-- Task priority -->
          <ng-container *ngIf="task.task_type === 'section' && task.project_stage_id">
            <div class="priority">
              <div class="labels">
                <div class="label text-blue-100 bg-blue-500">{{ task.project_stage }}</div>
              </div>
            </div>
          </ng-container>
          <!-- Task progress -->
          <div class="section-container__item__header__progress-info">
            <mat-progress-bar
              color="success"
              mode="determinate"
              [matTooltip]="task.percent_complete + '% complete'"
              [value]="task.percent_complete"
            >
            </mat-progress-bar>
            <span>{{ task.num_closed_children }} / {{ task.num_children }}</span>
          </div>
          <!-- Task actions -->
          <div class="section-container__item__header__actions">
            <button
              mat-button
              color="secondary"
              data-cy="add-task-to-section-button"
              (click)="relayCreateTask({ taskType: 'task', parentId: task.id })"
            >
              <mat-icon svgIcon="add"></mat-icon>
              Task
            </button>
            <button mat-button color="secondary" (click)="relayCreateTask({ taskType: 'key_date', parentId: task.id })">
              <mat-icon svgIcon="add"></mat-icon>
              Key Date
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="isAggregatedTask || (task.expanded && task.children?.length)">
      <div
        class="section-container__item__task-container"
        [class.section-container__item__task-container--aggregated]="isAggregatedTask"
      >
        <ng-container
          *ngTemplateOutlet="taskTemplate; context: { $implicit: task, sectionChild: false }"
        ></ng-container>
      </div>
    </ng-container>
  </article>
</section>

<ng-template #taskTemplate let-task let-sectionChild="sectionChild">
  <table
    #childTable
    mat-table
    [dataSource]="task.children"
    cdkDropList
    [cdkDropListData]="task.children"
    cdkDropListOrientation="vertical"
    (cdkDropListDropped)="listDropped($event, task.id)"
    class="table-container"
    [ngClass]="'child-table-' + task.id"
    [class.task-child]="!sectionChild"
    [multiTemplateDataRows]="true"
  >
    <ng-container matColumnDef="drag_control" *ngIf="!isAggregatedTask && !sectionChild">
      <th mat-header-cell *matHeaderCellDef="let row" class="drag_control"></th>
      <td mat-cell *matCellDef="let row" class="drag_control">
        <mat-icon svgIcon="drag_indicator" cdkDragHandle [matTooltip]="'Drag me'" class="hover-show"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="expand_control" *ngIf="!isAggregatedTask && !sectionChild">
      <th mat-header-cell *matHeaderCellDef="let row" class="expand_control"></th>
      <td mat-cell *matCellDef="let row" class="expand_control">
        <ng-container *ngIf="isSubtask(row)">
          <mat-icon [svgIcon]="'subdirectory_arrow_right'" [matTooltip]="'Sub task from ' + task.title"></mat-icon>
        </ng-container>
        <ng-container *ngIf="!isSubtask(row) && row.children.length !== 0">
          <mat-icon
            [svgIcon]="row.expanded ? 'expand_more' : 'chevron_right'"
            [matTooltip]="'Collapse/Expand'"
            (click)="sectionClick(row)"
          ></mat-icon>
        </ng-container>
      </td>
    </ng-container>
    <ng-container *ngFor="let column of dynamicColumns; let last = last">
      <ng-container [matColumnDef]="column.name">
        <th
          mat-header-cell
          *matHeaderCellDef="let row"
          class="dynamic-header"
          [class.last]="last"
          [class.mat-table-sticky--aggregated]="isAggregatedTask"
        >
          {{ column.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="dynamic-row_control"
          (click)="relayNavigateToTask(row, column)"
          data-cy="task-title-label"
        >
          <ng-container [ngSwitch]="column.name">
            <ng-container *ngSwitchCase="'title'">
              <div style="display: flex">
                <task-status
                  [condensedView]="condensedStatusView"
                  [task]="row"
                  (onUpdate)="relayUpdateTask(row)"
                  [readonly]="!canEdit"
                ></task-status>
                <span>{{ row.title }}</span>
                <span class="ml-1">
                  <mat-icon
                    [svgIcon]="'comment'"
                    style="height: 16px; width: 16px; min-height: 16px; min-width: 16px"
                    *ngIf="row.num_comments > 0"
                    [matTooltip]="'Has ' + row.num_comments + ' comments'"
                    (click)="navigateToComment($event, row)"
                  ></mat-icon>
                  <mat-icon
                    [svgIcon]="'format_list_bulleted'"
                    style="height: 16px; width: 16px; min-height: 16px; min-width: 16px"
                    class="ml-1"
                    *ngIf="row.num_todos > 0"
                    [matTooltip]="'Has ' + row.num_todos + ' checklist items'"
                  ></mat-icon>
                </span>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'start_date'">
              <ng-container *ngIf="row.workflow_state === 'complete'; else notTaskStartCompleted">
                {{ row.start_date | date: 'MMM dd, y' }}
              </ng-container>
              <ng-template #notTaskStartCompleted>
                <project-dialog-date-dropdown
                  (onUpdate)="relayUpdateTaskStartDate(row)"
                  [(ngModel)]="row.start_date"
                  ignoreOverdue="true"
                  notSetText="Start"
                  [endAt]="row.due_date"
                  [canEdit]="canEdit"
                ></project-dialog-date-dropdown>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'due_date'">
              <ng-container *ngIf="row.workflow_state === 'complete'; else notTaskCompleted">
                {{ row.due_date || row.completed_at | date: 'MMM dd, y' }}
              </ng-container>
              <ng-template #notTaskCompleted>
                <project-dialog-date-dropdown
                  [(ngModel)]="row.due_date"
                  (onUpdate)="relayUpdateTask(row)"
                  notSetText="Due"
                  [canEdit]="canEdit"
                ></project-dialog-date-dropdown>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'completed_at'">
              <project-dialog-date-dropdown
                [(ngModel)]="row.completed_at"
                (onUpdate)="relayUpdateTask(row)"
                notSetText="Finish"
                [canEdit]="canEdit"
              ></project-dialog-date-dropdown>
            </ng-container>
            <ng-container *ngSwitchCase="'assigned_user_id'">
              <project-dialog-full-user-dropdown
                [(ngModel)]="row.assigned_user_id"
                (onUpdate)="relayUpdateTask(row)"
                [users]="users"
                [canEdit]="canEdit"
              >
              </project-dialog-full-user-dropdown>
            </ng-container>
            <ng-container *ngSwitchCase="'task_list_id'">
              <div
                class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide blue-200 text-center"
                *ngIf="row?.task_list_name"
              >
                <ng-container *ngIf="row?.property_id && row?.task_list_id">
                  <a [routerLink]="['/properties/' + row?.property_id + '/tasks/' + row?.task_list_id]">
                    {{ row?.task_list_name }}
                  </a>
                </ng-container>

                <ng-container *ngIf="row?.project_id && row?.task_list_id">
                  <a
                    #propertyLink
                    *ngIf="row?.project_id"
                    [routerLink]="[
                      '/projects/' + row?.project?.pipeline_id + '/' + row?.project_id + '/tasks/' + row?.task_list_id,
                    ]"
                  >
                    {{ row?.task_list_name }}
                  </a>
                </ng-container>

                <ng-container *ngIf="!row?.project_id && !row?.property_id">
                  {{ row?.task_list_name }}
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'project_phase_id'">
              <div class="ml-3 inline-flex items-center px-2 py-2px" *ngIf="row?.project_phase">
                <span>{{ row?.project_phase }}</span>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'assigned_task_role_id'">
              <div class="ml-3 inline-flex items-center px-2 py-2px" *ngIf="row?.assigned_task_role_id">
                <span>{{ row?.assigned_task_role_name }}</span>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'project_stage_id'">
              <div class="ml-3 inline-flex items-center px-2 py-2px" *ngIf="row?.project_stage">
                <span>{{ row?.project_stage }}</span>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'project_id'">
              <div
                class="ml-3 inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide green-200"
                *ngIf="row?.project"
              >
                <a
                  [routerLink]="[
                    '/projects/' + row?.project?.pipeline_id + '/' + row?.project?.id + '/details/overview',
                  ]"
                  >{{ row?.object_name }}</a
                >
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'workflow_state'">
              <task-status
                [condensedView]="false"
                [task]="row"
                [taskStatuses]="taskStatuses"
                (onUpdate)="relayUpdateTask(row)"
                [readonly]="!canEdit"
              ></task-status>
            </ng-container>
            <ng-container *ngSwitchCase="'property_id'">
              <div
                class="ml-3 inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide green-200"
                *ngIf="row?.property"
              >
                <a [routerLink]="['/properties/' + row?.property?.id + '/details/overview']">{{ row?.object_name }}</a>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'task_list_template_id'">
              {{ row?.task_list_template_name }}
            </ng-container>
            <ng-container *ngSwitchCase="'last_comment_str'">
              <span
                class="last-comment"
                [matTooltip]="row?.last_comment | stripHtml"
                [innerHTML]="row?.last_comment | stripHtml"
              ></span>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <ng-container *ngIf="getDynamicColumnValue(row, column) as value">
                <span [class.placeholder]="value === 'Task Title'">{{ value }}</span>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>
    </ng-container>
    <ng-container matColumnDef="details_control">
      <th mat-header-cell *matHeaderCellDef="let row" class="details_control"></th>
      <td mat-cell *matCellDef="let row" class="details_control">
        <mat-icon
          (click)="relayNavigateToTask(row, { name: 'details_control' })"
          svgIcon="chevron_right"
          [matTooltip]="'Details'"
        ></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="taskChildren">
      <td mat-cell *matCellDef="let row" [attr.colspan]="columns.length">
        <ng-container *ngTemplateOutlet="taskTemplate; context: { $implicit: row, sectionChild: true }"></ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="keyDate">
      <td mat-cell *matCellDef="let row" [attr.colspan]="columns.length">
        <div class="mat-column-keyDate__item">
          <div class="mat-column-keyDate__item__left-icons">
            <mat-icon svgIcon="drag_indicator" cdkDragHandle class="hover-show" [matTooltip]="'Drag me'"></mat-icon>
          </div>
          <p class="mat-column-keyDate__item__title" [routerLink]="[row.id]">
            <strong>Key Date:</strong> <span [class.placeholder]="!row.title">{{ row.title || 'Key Date' }}</span>
          </p>
          <div class="mat-column-keyDate__item__dates">
            <ng-container *ngIf="row.workflow_state !== 'complete'; else completedDate">
              <project-dialog-date-dropdown
                [(ngModel)]="row.start_date"
                (onUpdate)="relayUpdateTask(row)"
                ignoreOverdue="true"
                notSetText="Start"
                [endAt]="row.due_date"
              ></project-dialog-date-dropdown>
              <project-dialog-date-dropdown
                [(ngModel)]="row.due_date"
                (onUpdate)="relayUpdateTask(row)"
                notSetText="Due"
              ></project-dialog-date-dropdown>
            </ng-container>
            <ng-template #completedDate>
              {{ row.due_date || row.completed_at | date: 'MMM dd, y' }}
            </ng-template>
          </div>
          <div class="mat-column-keyDate__item__user">
            <project-dialog-full-user-dropdown
              [(ngModel)]="row.assigned_user_id"
              (onUpdate)="relayUpdateTask(row)"
              [users]="users"
            >
            </project-dialog-full-user-dropdown>
          </div>
          <div class="mat-column-keyDate__item__right-icons">
            <mat-icon [routerLink]="[row.id]" [matTooltip]="'Details'" svgIcon="chevron_right"></mat-icon>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="groupItem">
      <td mat-cell *matCellDef="let row" colspan="999" class="section-container__item__group-header">
        <div>
          <p>
            <strong>{{ row.label }} ({{ row.totalCount }})</strong>
          </p>
        </div>
      </td>
    </ng-container>
    <ng-container *ngIf="!sectionChild">
      <tr mat-header-row *matHeaderRowDef="getColumnsHeaders(sectionChild); sticky: true"></tr>
    </ng-container>
    <tr
      mat-row
      *matRowDef="let row; columns: getColumnsHeaders(sectionChild); when: whenIsTask"
      cdkDrag
      cdkDragLockAxis="y"
      [cdkDragBoundary]="'.child-table-' + task.id + ' tbody'"
      class="child-table-row"
      [cdkDragDisabled]="isAggregatedTask"
      [class.expanded]="row.expanded"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['keyDate']; when: whenIsKeyDate"
      cdkDrag
      cdkDragLockAxis="y"
      [cdkDragDisabled]="isAggregatedTask"
      [cdkDragBoundary]="'.child-table-' + task.id + ' tbody'"
      class="child-table-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['groupItem']; when: whenIsGroupItem"
      cdkDrag
      cdkDragLockAxis="y"
      [cdkDragDisabled]="isAggregatedTask"
      [cdkDragBoundary]="'.child-table-' + task.id + ' tbody'"
      class="child-table-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['taskChildren']"
      [class.display-none]="isAggregatedTask || !row.expanded || !row.children?.length"
      class="child-table-row__children"
      [class.expanded]="row.expanded"
    ></tr>
  </table>
</ng-template>
